import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { MdOutlineClose } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from "react-select";
import AddAssignee from '../../../Components/AddAssignee/AddAssignee';
import AddAttachment from '../../../Components/AddAttachment/AddAttachment';
import Pagination from '../../../Components/Pagination/Pagination';
import { getInterestedTenders, selectedTotalDepartments } from '../../../Redux/Action/Dashboard';
import { addAssigneeApi, addCommentApi, addDocumentsApi, getAssigneesApi, getAttachmentsApi } from '../../../Redux/Action/InterestedTender';
import { departmentStyles, fileBaseUrl, getDropdownPosition, getSource, getUserDetail, tenderDate } from '../../../Utils/Helper';
import Loader from '../../../Utils/Loader';
import { addAssignee, attachIcon } from '../../../Utils/Svgs';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import './InterestedTender.css';
import PreviewTenderDetails from './PreviewTenderDetails';

const InterestedTenders = () => {
    const dispatch = useDispatch();

    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentId, setDepartmentId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showAssignee, setShowAssignee] = useState(false);
    const [selectedTender, setSelectedTender] = useState(null);
    const [showAttachmentId, setShowAttachmentId] = useState(null);
    const [reviewData, setReviewData] = useState(null);
    const [tenderlead, setTenderLeadId] = useState(null);
    const [detailModal, setDetailModal] = useState({
        show: false,
        text: ''
    });
    const [uploadModal, setUploadModal] = useState({
        show: false,
        type: '',
        tenderId: null,
        allTenderData: null
    });
    const [proceedModal, setProceedModal] = useState({
        show: false,
        type: '',
        tenderId: null
    });
    const [expandedItems, setExpandedItems] = useState({});
    const [stagedFiles, setStagedFiles] = useState([]);
    const [comment, setComment] = useState('');

    const { loading: departmentLoading, getTotalDepartments } = useSelector((state) => state.selectedTendersDepartments)
    const { loading, interestedTendersData } = useSelector((state) => state.interestedTendersGet)
    const { loading: assigneeLoading, getAddAssigneeData, error: assigneeError } = useSelector((state) => state.getAddAssignee)
    const { loading: commentLoading, getCommentsAddData, error: commentError } = useSelector((state) => state.getAddComments)
    const { loading: documentLoading, getDocumentAddData, error: documentError } = useSelector((state) => state.getAddDocuments)
    const { loading: getApplyTenderLoading, getApplyTenderData, error: applyTenderError } = useSelector((state) => state.getInterestedTenderApplied);

    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [limit]);

    useEffect(() => {
        dispatch({ type: "GET_ATTACHMENT_RESET" })
    }, [])

    // useEffect(() => {
    //     const formData = new FormData();
    //     formData.append("department_id", getUserDetail()?.department_id);
    //     dispatch(getInterestedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
    // }, []);

    useEffect(() => {
        if (selectedDepartment?.value === "all") {
            dispatch(getInterestedTenders({}, currentPage, limit))
        }
        else if (selectedDepartment) {
            const formData = new FormData();
            formData.append("department_id", selectedDepartment?.value);

            dispatch(getInterestedTenders(formData, currentPage, limit))
        }
        else {
            const formData = new FormData();
            formData.append("department_id", getUserDetail()?.department_id);
            dispatch(getInterestedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
        }
    }, [currentPage, limit]);

    useEffect(() => {
        dispatch(selectedTotalDepartments())

        return () => {
            dispatch({ type: "GET_SEARCH_DOCUMENT_RESET" })
        }
    }, [])

    useEffect(() => {
        if (getAddAssigneeData?.statusCode === 200) {
            successNotify("Assignee Added Successfully!");
            setShowAssignee(false);
            dispatch({ type: "ADD_ASSIGNEE_RESET" })

            if (selectedDepartment?.value === "all") {
                dispatch(getInterestedTenders(null, currentPage, limit))
            }
            else if (selectedDepartment) {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);

                dispatch(getInterestedTenders(formData, currentPage, limit))
            }
            else {
                const formData = new FormData();
                formData.append("department_id", getUserDetail()?.department_id);
                dispatch(getInterestedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
            }
        }
        else if (assigneeError) {
            errorNotify("Error Occurred");
            dispatch({ type: "ADD_ASSIGNEE_RESET" })
        }
    }, [getAddAssigneeData, assigneeError]);

    useEffect(() => {
        if (getCommentsAddData?.statusCode === 200) {
            successNotify("Comment Added");
            dispatch({ type: "ADD_COMMENT_RESET" })

            setComment('');

            const data = {
                tender_id: uploadModal?.tenderId,
                source_type: getSource(uploadModal?.type)
            }

            dispatch(getAttachmentsApi(data));

            if (selectedDepartment?.value === "all") {
                dispatch(getInterestedTenders(null, currentPage, limit))
            }
            else if (selectedDepartment) {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);

                dispatch(getInterestedTenders(formData, currentPage, limit))
            }
            else {
                const formData = new FormData();
                formData.append("department_id", getUserDetail()?.department_id);
                dispatch(getInterestedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
            }
        }
        else if (commentError) {
            errorNotify(commentError);
            dispatch({ type: "ADD_COMMENT_RESET" })
        }
    }, [getCommentsAddData, commentError]);

    useEffect(() => {
        if (getApplyTenderData?.statusCode === 200) {
            successNotify("Tender Applied Successfully!");
            dispatch({ type: "APPLY_TENDER_RESET" })

            if (selectedDepartment?.value === "all") {
                dispatch(getInterestedTenders(null, currentPage, limit))
            }
            else if (selectedDepartment) {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);

                dispatch(getInterestedTenders(formData, currentPage, limit))
            }
            else {
                const formData = new FormData();
                formData.append("department_id", getUserDetail()?.department_id);
                dispatch(getInterestedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
            }

            setProceedModal({
                show: false,
                type: '',
                tenderId: null
            })

        }
        else if (applyTenderError) {
            errorNotify(applyTenderError);
            dispatch({ type: "APPLY_TENDER_RESET" })
        }
    }, [getApplyTenderData, applyTenderError]);

    useEffect(() => {
        if (getDocumentAddData?.statusCode === 200) {
            successNotify("Document Added");
            dispatch({ type: "ADD_DOCUMENT_RESET" })

            setStagedFiles([]);

            const data = {
                tender_id: uploadModal?.tenderId,
                source_type: getSource(uploadModal?.type)
            }

            dispatch(getAttachmentsApi(data));

            if (selectedDepartment?.value === "all") {
                dispatch(getInterestedTenders(null, currentPage, limit))
            }
            else if (selectedDepartment) {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);

                dispatch(getInterestedTenders(formData, currentPage, limit))
            }
            else {
                const formData = new FormData();
                formData.append("department_id", getUserDetail()?.department_id);
                dispatch(getInterestedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
            }
        }
        else if (documentError) {
            errorNotify(documentError);
            dispatch({ type: "ADD_DOCUMENT_RESET" })
        }
    }, [getDocumentAddData, documentError]);

    const departOption = [
        { value: 'all', label: 'Select All' },
        ...(Array.isArray(getTotalDepartments?.data)
            ? getTotalDepartments?.data?.map((d) => ({
                value: d?.id,
                label: d?.name
            }))
            : [])
    ];

    const truncateText = (text, id, wordCount = 7) => {
        const words = text.split(' ');

        if (words.length <= wordCount) {
            return <span style={{ color: '#373737', fontWeight: '500', fontSize: '14px' }}>{text}</span>;
        }

        return (
            <span style={{ color: '#373737', fontWeight: '500', fontSize: '14px' }}>
                {expandedItems[id] ? text : `${words.slice(0, wordCount).join(' ')}`}
                <span style={{ color: '#666' }}>
                    {!expandedItems[id] && '...'}
                    <span
                        onClick={() => setExpandedItems(prev => ({
                            ...prev,
                            [id]: !prev[id]
                        }))}
                        style={{ color: '#003A70', cursor: 'pointer', fontWeight: '600', marginLeft: '4px' }}
                    >
                        {expandedItems[id] ? 'Show less' : 'Show more'}
                    </span>
                </span>
            </span>
        );
    };

    const searchDepartmentHandler = (selected) => {
        if (!selected) {
            errorNotify("Please Select Department");
            return;
        }

        setSelectedDepartment(selected);
        setCurrentPage(1);

        if (selected.value === "all") {
            dispatch(getInterestedTenders(null, currentPage, limit))
        } else if (selected?.value) {
            const formData = new FormData();
            formData.append("department_id", selected?.value);

            dispatch(getInterestedTenders(formData, currentPage, limit))
        }
    };

    const addAssigneeHandler = (data) => {
        if (getUserDetail()?.role === 'user') {
            errorNotify("You don't have permission to assign users");
            return
        }

        setDepartmentId(data?.department_id)
        setTenderLeadId(data?.tender_lead);

        const formData = new FormData();
        formData.append("tender_id", data.id);

        dispatch(getAssigneesApi(formData));

        setSelectedTender(data.id);
        setShowAssignee(true);
    }

    const getSourceType = (type) => {
        switch (type) {
            case 'technical':
                return 'technical_feasibility';
            case 'financial':
                return 'financial_feasibility';
            case 'tax':
                return 'tax_certificate';
            case 'other':
                return 'other';
            default:
                return type;
        }
    };

    const handleAssigneeSubmit = (data) => {
        const { assignments, tender_lead } = data;

        const tender_assignees = assignments
            .filter(assignment => assignment.assignees.length > 0)
            .map(assignment => ({
                user_ids: assignment.assignees.map(assignee => assignee.value),
                due_date: assignment.deadline ||
                    (assignment.assignees[0]?.tender_assign?.due_date || ""),
                source_type: getSourceType(assignment.type)
            }));

        if (tender_assignees?.length === 0) {
            errorNotify("Please assign at least one assignee");
            return;
        }

        const hasInvalidDeadline = tender_assignees.some(item =>
            item?.due_date === "" || item?.due_date === null
        );

        if (hasInvalidDeadline) {
            errorNotify("Please select deadline if you are selecting assignees");
            return;
        }

        const formattedData = {
            tender_id: selectedTender,
            tender_assignees,
            tender_lead_id: tender_lead
        };

        dispatch(addAssigneeApi(formattedData));
    };

    const toggleAttachment = (tender) => {
        if (tender?.assignees?.length === 0) {
            errorNotify("No document types assigned for this tender. Please assign document types before attaching files.");
            return;
        }
        setShowAttachmentId(current => current === tender?.id ? null : tender?.id);
    };

    const handleDocumentClick = (type, tenderId, allData) => {
        const data = {
            tender_id: tenderId,
            source_type: getSource(type)
        }

        dispatch(getAttachmentsApi(data));

        setUploadModal({
            show: true,
            type,
            tenderId,
            allTenderData: allData
        });
        setShowAttachmentId(null);
    };

    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.split(/[\s.]+/); // Split by space or dot
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    const getUniqueColor = (initials) => {
        const colors = [
            '#2E90FA', // blue
            '#2E77BC', // darker blue
            '#7F56D9', // purple
            '#9E77ED', // light purple
            '#F63D68', // pink
            '#DC6803', // orange
            '#049F76', // green
            '#667085', // gray
        ];

        // Use initials string to generate consistent color index
        const index = initials.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return colors[index % colors.length];
    };

    const handleAttachmentCommentSubmit = (data) => {
        const formData = new FormData();
        formData.append("tender_id", uploadModal.tenderId);
        formData.append("source_id", uploadModal.tenderId);
        formData.append("source_type", getSource(uploadModal.type));
        formData.append("comment", data.text);

        dispatch(addCommentApi(formData));
    }

    const handleAttachmentDocumentsSubmit = (data) => {
        const formData = new FormData();

        formData.append("tender_id", uploadModal.tenderId);
        formData.append("source_id", uploadModal.tenderId);
        formData.append("source_type", getSource(uploadModal.type));

        data.files.forEach(file => {
            formData.append("media", file?.file);
        });

        dispatch(addDocumentsApi(formData));
    }

    const proceedInterestedTenderHandler = (data) => {
        if (data?.tender_documentation === null) {
            errorNotify("Please attached any one document for proceed");
            return;
        }

        const userRole = getUserDetail()?.role;
        const userId = getUserDetail()?.id;
        const isPermitted =
            userRole === 'super-admin' ||
            userRole === 'admin' ||
            userId === data?.tender_lead_id;

        if (!isPermitted) {
            errorNotify("You don't have permission to proceed");
            return;
        }

        setReviewData(data);
        setProceedModal({
            show: true,
            type: 'Review',
            tenderId: data?.id
        });
    }

    return (
        <div className='dashboard_main' style={{ padding: "15px 10px" }}>
            <h1> Interested Tenders </h1>

            {
                getUserDetail()?.role === 'super-admin' &&
                <Row className='align-items-end pb-3' style={{ borderBottom: "1px solid #8080804d" }}>
                    <Col md={3}>
                        <Form.Group className="form_field">
                            <Form.Label>Department </Form.Label>
                            <Select
                                isLoading={departmentLoading}
                                onChange={searchDepartmentHandler}
                                options={departOption || []}
                                placeholder="Select Department"
                                styles={departmentStyles}
                                value={selectedDepartment}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }

            <div className='mt-3 mx-3'>
                {
                    loading ? <Loader /> :
                        <Row style={{ gap: "15px 0" }}>
                            {
                                interestedTendersData?.data?.results?.map((t, index) => {
                                    return (
                                        <Col md={6} lg={6} xl={6} key={t.id} style={{ marginTop: "15px" }}>
                                            <div style={{ position: "relative", height: "100%" }}>
                                                <div className='interested_tender_box'>
                                                    <div className='assignee_user_assign'>
                                                        {
                                                            t?.assignees?.length > 0 && (
                                                                <>
                                                                    {t?.assignees?.map((user, index) => {
                                                                        const initials = getInitials(user?.user?.user_name);
                                                                        return (
                                                                            <OverlayTrigger
                                                                                key={index}
                                                                                placement="top"
                                                                                overlay={
                                                                                    <Tooltip id={`tooltip-${index}`}>
                                                                                        {user?.user?.user_name}
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <span
                                                                                    className='users'
                                                                                    style={{ backgroundColor: getUniqueColor(initials) }}
                                                                                >
                                                                                    {initials}
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        )
                                                                    })}
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            t?.tender_lead &&
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-${11}`}>
                                                                        Tender Lead: {t?.tender_lead?.user_name}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <span
                                                                    className='users tender_lead'
                                                                    style={{ backgroundColor: "#003A70", border: "2px solid yellow" }}
                                                                >
                                                                    {getInitials(t?.tender_lead?.user_name)}
                                                                </span>
                                                            </OverlayTrigger>
                                                        }
                                                        <span onClick={() => addAssigneeHandler(t)}>{addAssignee}</span>
                                                    </div>
                                                    <Row>
                                                        <Col md={5}>
                                                            <p><span>Tender No.</span> {t.tenderNo} </p>
                                                        </Col>
                                                        <Col md={7}>
                                                            <p><span>Tender Company: </span> {t.company} </p>
                                                        </Col>
                                                        <Col md={5}>
                                                            <p><span>Tender Advertise Date: </span> <b className='advertise_date'>{t.advertiseDate}</b> </p>
                                                        </Col>
                                                        <Col md={7}>
                                                            <p><span>Tender Closing Date: </span> <b className={tenderDate(t.closingDate)}> {t.closingDate} </b> </p>
                                                        </Col>
                                                        <Col md={12}>
                                                            <p>
                                                                <span>Tender Detail: </span>
                                                                {truncateText(t.detail, t.id)}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                    <div className='interested_tender_btn'>
                                                        {!t.document ? (
                                                            <button
                                                                className='download_doc_btn'
                                                                style={{
                                                                    opacity: 0.6,
                                                                    cursor: 'not-allowed',
                                                                }}
                                                                title="No Attachment Available"
                                                                disabled
                                                            >
                                                                Download
                                                            </button>
                                                        ) :
                                                            <Link to={`${fileBaseUrl}/${t.document}`} target="_blank" className='download_doc_btn'>
                                                                Download
                                                            </Link>
                                                        }
                                                        <button className='attach_btn' onClick={() => toggleAttachment(t)}>
                                                            {attachIcon} Attach
                                                        </button>

                                                        {
                                                            getUserDetail()?.role !== "user" &&
                                                            <button onClick={() => proceedInterestedTenderHandler(t)}>Proceed</button>
                                                        }

                                                        {showAttachmentId === t.id && (
                                                            <div className={`attachment_dropdown ${getUserDetail()?.role === 'user' ? 'align_right' : ''}  ${getDropdownPosition(index, interestedTendersData?.data?.results?.length)}`}>
                                                                <ul>
                                                                    <li onClick={() => handleDocumentClick('Technical Feasibility', t.id, t)}>Technical Feasibility</li>
                                                                    <li onClick={() => handleDocumentClick('Financial Feasibility', t.id, t)}>Financial Feasibility</li>
                                                                    <li onClick={() => handleDocumentClick('Tax Certificate', t.id, t)}>Tax Certificate</li>
                                                                    <li onClick={() => handleDocumentClick('Other', t.id, t)}>Other</li>
                                                                    {/* <li>All</li> */}
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                            {
                                interestedTendersData?.data?.results?.length > 0 &&
                                <Pagination
                                    totalPages={interestedTendersData?.data?.meta?.totalPages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setLimit={setLimit}
                                    limit={limit} />
                            }
                            {interestedTendersData?.data?.results?.length === 0 && <h5 style={{ fontWeight: "600" }} className='text-center my-3'>No Data Found</h5>}
                        </Row>
                }
            </div>

            <AddAssignee
                show={showAssignee}
                onHide={() => setShowAssignee(false)}
                loading={assigneeLoading}
                onSubmit={handleAssigneeSubmit}
                department_id={departmentId}
                tenderLead={tenderlead}
            />

            <AddAttachment
                uploadModal={uploadModal}
                setUploadModal={() => setUploadModal({ show: false, type: '', tenderId: null, allTenderData: null })}
                loading={commentLoading}
                onSubmit={handleAttachmentCommentSubmit}
                documentLoading={documentLoading}
                onDocumentSubmit={handleAttachmentDocumentsSubmit}
                stagedFiles={stagedFiles}
                setStagedFiles={setStagedFiles}
                comment={comment}
                setComment={setComment}
            />

            <PreviewTenderDetails
                uploadModal={proceedModal}
                setUploadModal={() => setProceedModal({ show: false, type: '', tenderId: null })}
                reviewData={reviewData}
                getApplyTenderLoading={getApplyTenderLoading}
                showApply={true}
            />

            <Modal centered className='doc_type' show={detailModal.show}>
                <Modal.Body>
                    <div className='add_doc_type'>
                        <div className='head'>
                            <h5>Tender Detail</h5>
                            <MdOutlineClose onClick={() => setDetailModal({ show: false, text: '' })} />
                        </div>
                        <div className='m-4'>
                            <p style={{ margin: 0 }}>{detailModal.text}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default InterestedTenders;